import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {CreateTechnicalConclusion, TechnicalConclusion} from "../../types/technical-conclusion-types";
import {defaultTechnicalConclusionData} from "../../config/default-technical-conclusion-data";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {TechnicalConclusionModalService} from "../../services/technical-conclusion-modal.service";
import {RecordUpdateRequestParams} from "../../../../../../../../core/types/records-table.types";
import {technicalConclusionResourceType} from "../../config/technical-conclusion-config";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {technicalConclusionFormFields} from "../../config/technical-conclusion-form-fields";

@Component({
  selector: 'app-technical-conclusion-form',
  imports: [
    CdkTextareaAutosize,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule
  ],
  templateUrl: './technical-conclusion-form.component.html',
  styleUrl: './technical-conclusion-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TechnicalConclusionFormComponent {
  parentId =  input<number>(0);
  technicalConclusionData =  input<TechnicalConclusion>(defaultTechnicalConclusionData);
  technicalConclusionFormGroup =  input<FormGroup>(new FormGroup({}));
  noFirstData =  input<boolean>(false);
  isEditModeActive =  input<boolean>(false);
  updateTechnicalConclusionData = output<TechnicalConclusion>();
  deleteTechnicalConclusion = output<void>();

  private technicalConclusionModalService: TechnicalConclusionModalService = inject(TechnicalConclusionModalService);

  public readonly technicalConclusionFormFields = technicalConclusionFormFields;

  public getFieldClass(): string {
    if (!this.technicalConclusionData().id) { return ''; }

    return this.isEditModeActive() ? '' : 'none-pointer-events';
  }

  public async handleValueChange(key: string): Promise<void> {
    if (!this.technicalConclusionData().id) { return; }

    const params: RecordUpdateRequestParams = {
      path: technicalConclusionResourceType.path,
      recordId: this.technicalConclusionData().id,
      fieldName: key,
      value: this.technicalConclusionFormGroup().get(key)?.value
    };

    const data = await this.technicalConclusionModalService.updatedRecordField<TechnicalConclusion>(params)
      .catch(() => this.technicalConclusionData());
    this.updateTechnicalConclusionData.emit(data);
  }

  public handelDelete(): void {
    this.deleteTechnicalConclusion.emit();
  }

  public async handelCreate(): Promise<void> {
    const createTechnicalConclusion: CreateTechnicalConclusion = {
      technicalParametersId: this.parentId(),
      ...this.technicalConclusionFormGroup().value
    };

    const data = await this.technicalConclusionModalService.createTechnicalConclusion(createTechnicalConclusion)
      .catch(() => defaultTechnicalConclusionData);
    this.updateTechnicalConclusionData.emit(data);
  }
}
